module.exports = __webpack_public_path__ + "img/england.f60a4abb.svg";